import loadable from '@loadable/component';

export const AdminsLinksLoadable = loadable(() => import('./AdminsLinks'), {
  resolveComponent: (module) => module.AdminsLinks,
});
